import React           from 'react'
import { Icon }        from 'antd'

import './file-results.scss'

export default ({ files, selected_file_index, on_file_select }) => {
  return (
    <div className='file-results'>
      {
        files.length > 0 ?
          files.map((file, index) => {
            const {key, bucket_name, name, path, size, type} = file||{}
            return (
              <div className={index === selected_file_index ? 'file-item selected' : 'file-item'}
                   key={index} onClick={on_file_select.bind(null, index)}>
                <Icon type="file-text" size={'large'} className='file-icon'/>
                <div>
                  <span>{name}</span>
                  <span>{bucket_name}</span>
                </div>
              </div>
            )
          }) : <p>No result found with this keyword</p>
      }
    </div>
  )
}
